import { EncounterAddendum, EncounterSummaryControllerApi } from "@/services";
import { getConfigObject, useMutationWithLoading } from "@/utils/utils";

/** Signs the one addendum of a signed-off visit; only the rendering provider can. */
export const useSignAddendum = () =>
  useMutationWithLoading(
    async (params: {
      appointmentUuid: string;
      encounterAddendum: EncounterAddendum;
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(getConfigObject()).signAddendum(
        params.appointmentUuid,
        params.encounterAddendum,
        params.xTENANTID
      )
  );
